/**
 * @Author : DingHuiHui
 * @Content : 我的卡包
 */
import $http from '@/utils/requestAxios'

export const apiCard = {
  // 列表
  list (params) {
    return $http.get('/cardpkg', params)
  },
  // 重新获取
  reget (cardNo) {
    return $http.put('/giftcard/reget', { cardNo }, {}, 'admin')
  }
}
